"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";

export function SearchInputClearButton({
  clearSearchProps = {},
  showClearButton = true,
}) {
  return showClearButton ? (
    <Link
      block={"inline"}
      button={false}
      className={"search_clear-button"}
      options={{
        href: "#",
      }}
      {...clearSearchProps}
    >
      <Block className={"clear-button_wrapper"} tag={"div"}>
        <HtmlEmbed
          className={"icon-embed-xxsmall"}
          content={
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--fe" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.657 12.071L5 6.414L6.414 5l5.657 5.657L17.728 5l1.414 1.414l-5.657 5.657l5.657 5.657l-1.414 1.414l-5.657-5.657l-5.657 5.657L5 17.728z"/></svg>'
          }
        />
      </Block>
    </Link>
  ) : null;
}
